import React, { Component, Context } from "react";
import { FirebaseContext } from "../firebase/context";
import { IForm } from "../base/models/forms";
import { getCollection, addUpdateDocumentInCollection } from "../base/firestore-utils";
import DataUtils from "../helpers/data-utils";
import { IFirebaseContext } from "../base/firebase";

export interface IFirebaseUtils {
	getCollection: typeof getCollection;
	addUpdateDocumentInCollection: typeof addUpdateDocumentInCollection;
	getForm: (id: string) => Promise<IForm>;
	getForms: () => Promise<IForm[]>;
	addFormSubmission: (formId: string, formValues, formConfig: IForm, userPayload?) => Promise<any>;
}

const withFirebaseUtils = (WrappedComponent): any => {
	return class extends Component {
		static contextType: Context<IFirebaseContext> = FirebaseContext;

		render() {
			if (!this.context || !this.context.tenant) {
				console.log("WARNING: provide FirebaseContext and tenant above");
			} else {
				DataUtils.loadTenant(this.context);
			}

			const utils: IFirebaseUtils = {
				getCollection,
				addUpdateDocumentInCollection,
				getForm: DataUtils.getForm,
				getForms: DataUtils.getForms,
				addFormSubmission: DataUtils.addFormSubmission,
			};

			return <WrappedComponent key={this.context?.tenant} {...utils} {...this.props} />;
		}
	};
};

export default withFirebaseUtils;
